import Form, { Field } from '../../../lib/recoil/Form';
import { RequireAdditionalFinancingOption } from '../../../types/eslProfileFinancingForm';

/**
 * Manages the state of the program questions form
 */
const financingForm = new Form({
  fields: {
    // Program step
    existingStudentLoans: new Field<boolean | null>({
      key: 'existingStudentLoans',
      defaultValue: null,
      persists: false,
      rules: [],
    }),
    additionalFinancing:  new Field<RequireAdditionalFinancingOption | null>({
      key: 'additionalFinancing',
      defaultValue: null,
      persists: false,
      rules: [],
    }),
  },
});

export default financingForm;
